import req from '@/api/utilities/axios';


export const logOut = (): Promise<any> => req.post(`auth/saml/logout`);


export const authCheck = (payload: {code: string}): Promise<any> => req.post(`auth/saml/check`, payload);
